module.exports = __webpack_public_path__ + "static/media/dec.5771a293.jpg";